//  import logoImg from "../../assets/images/logo.svg";
import logoImg from "assets/images/logo.png"
import classnames from "classnames"
import { ErrorMessage, Field, Formik, useFormik } from "formik"
import React, { useEffect, useState } from "react"
//redux
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Alert,
  Form,
  Input,
  FormFeedback,
} from "reactstrap"
import {
  registerCompany,
  registerPersonalUser,
  registerPersonalUserError,
  registerCompanyError,
  registerPersonalUserSuccess,
  registerCompanySuccess,
} from "store/auth/register/actions"
// Formik Validation
import * as Yup from "yup"
// import images
import profileImg from "../../assets/images/profile-img.png"
import { Redirect } from "react-router-dom"
// action

import "./accounttype.scss"
import { Countries } from "pages/Admin/ManageUser/countries"

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

var formikOnChangeValues = {}

const Register = props => {
  //meta title
  document.title =
    "Register | TenderSoftware - Flexi TracBoard"

  const dispatch = useDispatch()

  const [activeTab, setActiveTab] = useState("1")
  const [registertype, setResigterTpe] = useState("company")
  const [company, setcompany] = useState("")
  const [emailAlreadyExist, setEmailAlreadyExist] = useState(false)
  const [isShowPassword, setisShowPassword] = useState(false)
  const [isShowVerifyPassword, setisShowVerifyPassword] = useState(false)

  const formikCompany = useFormik({
    enableReinitialize: true,
    initialValues: {
      companyname: "",
      contactname: "",
      phone: "",
      email: "",
      defaultprojectname: "",
      firstname: "",
      lastname: "",
      address: '',
      country: 'India',
      postcode: '',
      domain: '',
    },
    validationSchema: Yup.object().shape({
      companyname: Yup.string().required("Please enter your Company name"),
      contactname: Yup.string().required("Please enter your Contact name"),
      firstname: Yup.string().required("Please enter your First name"),
      lastname: Yup.string().required("Please enter your Last name"),
      address: Yup.string().required("Please enter your Address"),
      postcode: Yup.string().required("Please enter your postcode"),
      domain: Yup.string().required("Please enter your domain"),
      phone: Yup.string()
        .required("Please enter your Phone Number")
        .min(10)
        .max(10)
        .matches(phoneRegExp, "Phone number is not valid"),
      email: Yup.string().required("Please enter your Email"),
      defaultprojectname: Yup.string().required(
        "Please enter your Project Name"
      ),
    }),
    onSubmit: values => {
      handleCompanySignup(values)
    },
  })

  const formikUser = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      useremail: "",
      phonenumber: "",
      password: "",
      password_confirmation: "",
    },
    validationSchema: Yup.object().shape({
      username: Yup.string().required("Please enter your name"),
      useremail: Yup.string().required("Please enter your Email"),
      phonenumber: Yup.string()
        .required("Please enter your Phone Number")
        .min(10)
        .max(10)
        .matches(phoneRegExp, "Phone number is not valid"),
      password: Yup.string().required("Please enter your Password").min(6),
      password_confirmation: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords don't match!")
        .required("Please Enter Your Verify Password"),
    }),
    onSubmit: values => {
      handlePersonalSignup(values)
    },
  })

  const [formData, setFormData] = useState({
    email: "",
    companyname: "",
    contactname: "",
    password: "",
    password_confirmation: "",
    phone: "",
    company: "",
    username: "",
    useremail: "",
    defaultprojectname: "",
    phonenumber: "",
  })

  const {
    user,
    userRegistrationError,
    companyloading,
    userloading,
    companyRegistrationError,
    companyRegistrationSuccess,
    userRegistrationSuccess,
  } = useSelector(state => ({
    userRegistrationSuccess: state.Account.userRegistrationSuccess,
    companyRegistrationSuccess: state.Account.companyRegistrationSuccess,
    companyRegistrationError: state.Account.companyRegistrationError,
    userRegistrationError: state.Account.userRegistrationError,
    companyloading: state.Account.companyloading,
    userloading: state.Account.userloading,
  }))

  const toggleTab = tab => {
    dispatch(registerPersonalUserError(""))
    dispatch(registerCompanyError(""))

    if (activeTab !== tab) {
      setActiveTab(tab)
      setFormData({
        email: "",
        companyname: "",
        contactname: "",
        password: "",
        password_confirmation: "",
        phone: "",
        company: "",
        username: "",
        useremail: "",
        defaultprojectname: "",
        phonenumber: "",
      })
    }
  }

  useEffect(() => {
    dispatch(registerPersonalUserError(""))
    dispatch(registerCompanyError(""))
  }, [])

  const handleCompanySignup = values => {
    dispatch(registerCompanySuccess(""))
    var company = {
      companyName: values?.companyname,
        contactName: values?.contactname,
        subCategoryName: values?.defaultprojectname,
        email: values?.email,
        phoneNumber: JSON.stringify(values?.phone),
        contactFirstName: values?.firstname,
        contactLastName: values?.lastname,
        address: values?.address,
        country: values?.country,
        postCode: JSON.stringify(values?.postcode),
        domain: values?.domain,
        defaultCategoryId: 0,
        defaultSubcategoryId: 0,
    }
    dispatch(registerCompany(company, props.history))
  }

  const handlePersonalSignup = values => {
    dispatch(registerPersonalUserSuccess(""))
    var user = {
      contactName: values.username,
      email: values.useremail,
      password: values.password,
      phoneNumber: values.phonenumber,
    }
    dispatch(registerPersonalUser(user, props.history))
  }
  useEffect(() => {
    if (companyRegistrationSuccess?.statusCode === "200") {
      formikCompany.resetForm()
    }
    if (userRegistrationSuccess?.statusCode === 200) {
      formikUser.resetForm()
    }
  }, [companyRegistrationSuccess, userRegistrationSuccess])

  const handleSubmitCompany = e => {
    e.preventDefault()
    formikCompany.handleSubmit()
  }
  const handleSubmitUser = e => {
    e.preventDefault()
    formikUser.handleSubmit()
  }

  return (
    <React.Fragment>
      <div id="account-types">
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Free Register</h5>
                          <p>Get your free FlexiTracBoard account now.</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profileImg} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/">
                        <div className="avatar-md profile-user-wid mb-2">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logoImg}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>

                    <Row className="navtab-main mb-4">
                      <Nav pills className="navtab-bg nav-justified">
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "1",
                            })}
                            onClick={() => {
                              toggleTab("1")
                            }}
                          >
                            Company
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: activeTab === "2",
                            })}
                            onClick={() => {
                              toggleTab("2")
                            }}
                          >
                            Personal
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Row>

                    {activeTab === "1" ? (
                      <>
                        <Form onSubmit={handleSubmitCompany}>
                          <div className="form-horizontal">
                            <>
                              {companyRegistrationError &&
                                companyRegistrationError &&
                                !companyloading ? (
                                <Alert color="danger">
                                  {companyRegistrationError?.message}
                                </Alert>
                              ) : null}

                              {companyRegistrationSuccess ? (
                                <Alert
                                  color="success"
                                  style={{ marginTop: "13px" }}
                                >
                                  {companyRegistrationSuccess?.message}
                                </Alert>
                              ) : null}
                              <div className="mb-3">
                                <Label for="companyname" className="form-label">
                                  Company Name
                                </Label>
                                <Input
                                  name="companyname"
                                  className="form-control"
                                  placeholder="Enter Your Company Name"
                                  type="text"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.companyname || ""}
                                  invalid={
                                    formikCompany.touched.companyname &&
                                      formikCompany.errors.companyname
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.companyname &&
                                  formikCompany.errors.companyname ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.companyname}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <Label for="contactname" className="form-label">
                                  Contact Name
                                </Label>
                                <Input
                                  name="contactname"
                                  className="form-control"
                                  placeholder="Enter Your Contact Name"
                                  type="text"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.contactname || ""}
                                  invalid={
                                    formikCompany.touched.contactname &&
                                      formikCompany.errors.contactname
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.contactname &&
                                  formikCompany.errors.contactname ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.contactname}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label for="firstname" className="form-label">
                                  First Name
                                </Label>
                                <Input
                                  name="firstname"
                                  className="form-control"
                                  placeholder="Enter Your First Name"
                                  type="text"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.firstname || ""}
                                  invalid={
                                    formikCompany.touched.firstname &&
                                      formikCompany.errors.firstname
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.firstname &&
                                  formikCompany.errors.firstname ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.firstname}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label for="lastname" className="form-label">
                                  Last Name
                                </Label>
                                <Input
                                  name="lastname"
                                  className="form-control"
                                  placeholder="Enter Your Last Name"
                                  type="text"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.lastname || ""}
                                  invalid={
                                    formikCompany.touched.lastname &&
                                      formikCompany.errors.lastname
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.lastname &&
                                  formikCompany.errors.lastname ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.lastname}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label for="address" className="form-label">
                                  Address
                                </Label>
                                <Input
                                  name="address"
                                  className="form-control"
                                  placeholder="Enter Your Address"
                                  type="text"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.address || ""}
                                  invalid={
                                    formikCompany.touched.address &&
                                      formikCompany.errors.address
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.address &&
                                  formikCompany.errors.address ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.address}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label for="postcode" className="form-label">
                                  postcode
                                </Label>
                                <Input
                                  name="postcode"
                                  className="form-control"
                                  placeholder="Enter Your postcode"
                                  type="number"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.postcode || ""}
                                  invalid={
                                    formikCompany.touched.postcode &&
                                      formikCompany.errors.postcode
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.postcode &&
                                  formikCompany.errors.postcode ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.postcode}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label for="domain" className="form-label">
                                  Domain
                                </Label>
                                <Input
                                  name="domain"
                                  className="form-control"
                                  placeholder="Enter Your domain"
                                  type="text"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.domain || ""}
                                  invalid={
                                    formikCompany.touched.domain &&
                                      formikCompany.errors.domain
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.domain &&
                                  formikCompany.errors.domain ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.domain}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <Label for="phone" className="form-label">
                                  Phone Number
                                </Label>
                                <Input
                                  name="phone"
                                  className="form-control"
                                  placeholder="Enter Your Phone Number"
                                  type="number"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.phone || ""}
                                  invalid={
                                    formikCompany.touched.phone &&
                                      formikCompany.errors.phone
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.phone &&
                                  formikCompany.errors.phone ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.phone}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label className="form-label">Country</Label>
                                <Input
                                  id="country"
                                  type="select"
                                  name="country"
                                  value={formikCompany.values.country || ""}
                                  onBlur={formikCompany.handleBlur}
                                  onChange={formikCompany.handleChange}
                                  invalid={
                                    formikCompany.touched.country && formikCompany.errors.country
                                      ? true
                                      : false
                                  }
                                >
                                  <option key={`optionVal_empty`} value="">
                                    Please Select country
                                  </option>
                                  {(Countries || [])?.map((option, i) => (
                                    <option key={`optionVal_${i}`} value={option?.id}>
                                      {option?.name}
                                    </option>
                                  ))}
                                </Input>

                                {formikCompany.touched.country && formikCompany.errors.country ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.country}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <Label for="email" className="form-label">
                                  Email
                                </Label>
                                <Input
                                  name="email"
                                  className="form-control"
                                  placeholder="Enter Your Email"
                                  type="text"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={formikCompany.values.email || ""}
                                  invalid={
                                    formikCompany.touched.email &&
                                      formikCompany.errors.email
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.email &&
                                  formikCompany.errors.email ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.email}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <Label
                                  for="defaultprojectname"
                                  className="form-label"
                                >
                                  Project Name
                                </Label>
                                <Input
                                  name="defaultprojectname"
                                  className="form-control"
                                  placeholder="Enter Your Project Name"
                                  type="text"
                                  onChange={formikCompany.handleChange}
                                  onBlur={formikCompany.handleBlur}
                                  value={
                                    formikCompany.values.defaultprojectname ||
                                    ""
                                  }
                                  invalid={
                                    formikCompany.touched.defaultprojectname &&
                                      formikCompany.errors.defaultprojectname
                                      ? true
                                      : false
                                  }
                                />
                                {formikCompany.touched.defaultprojectname &&
                                  formikCompany.errors.defaultprojectname ? (
                                  <FormFeedback type="invalid">
                                    {formikCompany.errors.defaultprojectname}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mt-3 d-grid">
                                <button
                                  className="btn btn-primary btn-block"
                                  type="submit"
                                >
                                  Register
                                </button>
                              </div>
                            </>
                          </div>
                        </Form>
                      </>
                    ) : (
                      <>
                        <Form onSubmit={handleSubmitUser}>
                          <div className="form-horizontal">
                            <>
                              {userRegistrationError &&
                                userRegistrationError &&
                                !userloading ? (
                                <Alert color="danger">
                                  {userRegistrationError?.message}
                                </Alert>
                              ) : null}

                              {userRegistrationSuccess ? (
                                <Alert
                                  color="success"
                                  style={{ marginTop: "13px" }}
                                >
                                  {userRegistrationSuccess?.message}
                                </Alert>
                              ) : null}

                              <div className="mb-3">
                                <Label for="username" className="form-label">
                                  Name
                                </Label>
                                <Input
                                  name="username"
                                  classusername="form-control"
                                  placeholder="Enter Your Name"
                                  type="text"
                                  onChange={formikUser.handleChange}
                                  onBlur={formikUser.handleBlur}
                                  value={formikUser.values.username || ""}
                                  invalid={
                                    formikUser.touched.username &&
                                      formikUser.errors.username
                                      ? true
                                      : false
                                  }
                                />
                                {formikUser.touched.username &&
                                  formikUser.errors.username ? (
                                  <FormFeedback type="invalid">
                                    {formikUser.errors.username}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label for="useremail" className="form-label">
                                  Email
                                </Label>
                                <Input
                                  name="useremail"
                                  classuseremail="form-control"
                                  placeholder="Enter Your Email"
                                  type="email"
                                  onChange={formikUser.handleChange}
                                  onBlur={formikUser.handleBlur}
                                  value={formikUser.values.useremail || ""}
                                  invalid={
                                    formikUser.touched.useremail &&
                                      formikUser.errors.useremail
                                      ? true
                                      : false
                                  }
                                />
                                {formikUser.touched.useremail &&
                                  formikUser.errors.useremail ? (
                                  <FormFeedback type="invalid">
                                    {formikUser.errors.useremail}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label for="phonenumber" className="form-label">
                                  Phone Number
                                </Label>
                                <Input
                                  name="phonenumber"
                                  classphonenumber="form-control"
                                  placeholder="Enter Your Phone Number"
                                  type="tel"
                                  onChange={formikUser.handleChange}
                                  onBlur={formikUser.handleBlur}
                                  value={formikUser.values.phonenumber || ""}
                                  invalid={
                                    formikUser.touched.phonenumber &&
                                      formikUser.errors.phonenumber
                                      ? true
                                      : false
                                  }
                                />
                                {formikUser.touched.phonenumber &&
                                  formikUser.errors.phonenumber ? (
                                  <FormFeedback type="invalid">
                                    {formikUser.errors.phonenumber}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <Label for="password" className="form-label">
                                  Password
                                </Label>
                                <Input
                                  name="password"
                                  classpassword="form-control"
                                  placeholder="Enter Your Password"
                                  type="password"
                                  onChange={formikUser.handleChange}
                                  onBlur={formikUser.handleBlur}
                                  value={formikUser.values.password || ""}
                                  invalid={
                                    formikUser.touched.password &&
                                      formikUser.errors.password
                                      ? true
                                      : false
                                  }
                                />
                                {formikUser.touched.password &&
                                  formikUser.errors.password ? (
                                  <FormFeedback type="invalid">
                                    {formikUser.errors.password}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <Label
                                  for="password_confirmation"
                                  className="form-label"
                                >
                                  Verify Password
                                </Label>
                                <Input
                                  name="password_confirmation"
                                  classpassword="form-control"
                                  placeholder="Enter Your Confirm Password"
                                  type="password"
                                  onChange={formikUser.handleChange}
                                  onBlur={formikUser.handleBlur}
                                  value={
                                    formikUser.values.password_confirmation ||
                                    ""
                                  }
                                  invalid={
                                    formikUser.touched.password_confirmation &&
                                      formikUser.errors.password_confirmation
                                      ? true
                                      : false
                                  }
                                />
                                {formikUser.touched.password_confirmation &&
                                  formikUser.errors.password_confirmation ? (
                                  <FormFeedback type="invalid">
                                    {formikUser.errors.password_confirmation}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mt-3 d-grid">
                                <button
                                  className="btn btn-primary btn-block"
                                  type="submit"
                                >
                                  Register
                                </button>
                              </div>
                            </>
                          </div>
                        </Form>
                      </>
                    )}

                    <div className="mt-3 text-center">
                      <p>
                        Already have an account ?{" "}
                        <Link to="/login" className="fw-medium text-primary">
                          {" "}
                          Login
                        </Link>{" "}
                      </p>
                    </div>
                  </CardBody>
                </Card>

                <div className="mt-2 text-center">
                  <p>© {new Date().getFullYear()} TenderSoftware.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Register
